// enum VariableGroup {
//     Seller = "Vendeur (Seller)",
//     TOUser = "Utilisateur TO (TO User)",
//     TripInformation = "Informations de voyage",
//     ProductDetails = "Détails du produit",
//     Agency = "Agence",
//     Sinister = "Sinistre (Sinister)",
//     Payment = "Paiement (Payment)",
//     Case = "Cas (Case)",
//     Undefined = "Catégorie non définie"
// }

// Définition des groupes de variables
enum VariableGroup {
    TripInformation = "trip", // dossier
    Destination = "destination", // destination
    ProductDetails = "product-details", // produit
    Contact = "contact", // contact
    Payment = "payment", // paiement
    Event = "event", // événement
    Provider = "provider", // fournisseur
    
    Seller = "agent-linked-to-trip", // Agent lié au dossier
    TOUser = "to-user-linked-to-trip", // utilisateur TO lié au dossier
    User = "User", // utilisateur
    Sender = "sender", // expéditeur/configuration de l'email (objet, image, ...) 
    Agency = "agency", // agence en général
    
    Case = "case", // case case_number (numéro du cas)                                                                            1 variable
    Sinister = "sinister", // sinistre                                                                                            2 variable

    Quotation = "quotation", // quotation

    Others = "others",
}

// Fonction pour déterminer le groupe d'une variable donnée
export function determineVariableGroup(variableName: string): VariableGroup {
    const variableGroups: Record<string, VariableGroup> = {
        
        case_number: VariableGroup.Others, // numéro du cas : classe non défini ?
        tkxl_date: VariableGroup.Others,  // date tkxl : classe non défini ?
        subject: VariableGroup.Sender, // objet par défaut de l'email
        link_picture: VariableGroup.Sender, // image d'illustration de l'email par défaut


        minisite_link: VariableGroup.Quotation, // lien vers le minisite : classe non défini ?
        signing_date: VariableGroup.Quotation,
        
        group_name: VariableGroup.User, // nom du groupe
        login_link: VariableGroup.User, // lien de connexion
        logo_client: VariableGroup.User, // url du logo de la société
        verification_code: VariableGroup.User,
        for_user_first_name: VariableGroup.User,
        for_user_last_name: VariableGroup.User,
        for_user_title: VariableGroup.User,
        reset_password_link: VariableGroup.User,
        
        agency_address: VariableGroup.Agency,
        agency_address_city: VariableGroup.Agency,
        agency_email: VariableGroup.Agency,
        agency_name: VariableGroup.Agency,
        agency_phone_number: VariableGroup.Agency,
        agency_price_edition_link: VariableGroup.Agency,
        agent_avatar: VariableGroup.Agency,
        agent_name: VariableGroup.Agency,        
        target_client_email: VariableGroup.Agency,
        target_client_name: VariableGroup.Agency,
        
        claim_creator_name: VariableGroup.Sinister, // nom du créateur du sinistre
        claim_reference: VariableGroup.Sinister, // référence du sinistre
        
        
        
        contact_first_name: VariableGroup.Contact,
        contact_last_name: VariableGroup.Contact,
        contact_title: VariableGroup.Contact,
        contact_traveler_first_name: VariableGroup.Contact,
        contact_traveler_last_name: VariableGroup.Contact,
        contact_traveler_phone: VariableGroup.Contact,
        contact_traveler_title: VariableGroup.Contact,
        contract_ref:  VariableGroup.Contact,
        trip_owner_contact_email: VariableGroup.Contact, // email du contact du propri

        currency: VariableGroup.Payment,
        paid_amount: VariableGroup.Payment,
        payment_date: VariableGroup.Payment,
        payment_deadline: VariableGroup.Payment,
        payment_method: VariableGroup.Payment,
        payment_reference: VariableGroup.Payment,
        days_overdue: VariableGroup.Payment,
        origin_due_date: VariableGroup.Payment,
        due_date: VariableGroup.Payment, // date de solde du voyage : voyage ou paiement ?

        
        dest_country_name: VariableGroup.Destination,
        dest_name: VariableGroup.Destination,
        destination_url_pict: VariableGroup.Destination,

        
        
        
        
        event_agent_email: VariableGroup.Event,
        event_agent_first_name: VariableGroup.Event,
        event_agent_last_name: VariableGroup.Event,
        event_agent_phone_number: VariableGroup.Event,
        event_link: VariableGroup.Event,
        event_name: VariableGroup.Event,
        
        
        date_hours: VariableGroup.ProductDetails,
        end_date: VariableGroup.ProductDetails,
        flight_price: VariableGroup.ProductDetails,
        hotel_address: VariableGroup.ProductDetails,
        hour_selected: VariableGroup.ProductDetails,
        internal_booking_ref: VariableGroup.ProductDetails,
        nb_people: VariableGroup.ProductDetails,
        new_price: VariableGroup.ProductDetails,
        variant_name: VariableGroup.ProductDetails,
        variant_ref: VariableGroup.ProductDetails,
        
        
        
        email_response_link: VariableGroup.Provider, // lien pour les actions du fournisseur
        email_response: VariableGroup.Provider, // url pour le fournisseur lors de réservation ou annulation de produit
        name_of_provider: VariableGroup.Provider,
        provider: VariableGroup.Provider,
        provider_booking_link: VariableGroup.Provider,
        provider_details: VariableGroup.Provider,
        provider_lib: VariableGroup.Provider,
        provider_name: VariableGroup.Provider,
        provider_quotation_link: VariableGroup.Provider,
        
        
        
        sender_avatar_url: VariableGroup.Sender,
        sender_email: VariableGroup.Sender,
        sender_first_name: VariableGroup.Sender,
        sender_last_name: VariableGroup.Sender,
        sender_phone_number: VariableGroup.Sender,
        sender_title: VariableGroup.Sender,
        
        principal_product_name: VariableGroup.ProductDetails,
        principal_product_ref: VariableGroup.ProductDetails,
        product_booking_status: VariableGroup.ProductDetails,
        product_name: VariableGroup.ProductDetails,
        product_ref: VariableGroup.ProductDetails,
        pnr_number: VariableGroup.ProductDetails,
        start_date: VariableGroup.ProductDetails,

        
        pax_info: VariableGroup.TripInformation,
        pax_weight: VariableGroup.TripInformation,
        number_of_travelers: VariableGroup.TripInformation,
        summary_quotation_link: VariableGroup.TripInformation,

        trip_access_link: VariableGroup.TripInformation,
        trip_cart_link: VariableGroup.TripInformation,
        trip_end_date: VariableGroup.TripInformation,
        trip_expected_deposit: VariableGroup.TripInformation,
        trip_name: VariableGroup.TripInformation,
        trip_note: VariableGroup.TripInformation,
        trip_reference: VariableGroup.TripInformation,
        trip_start_date: VariableGroup.TripInformation,
        trip_status: VariableGroup.TripInformation,
        trip_total_price: VariableGroup.TripInformation,
        trip_url: VariableGroup.TripInformation,
        version_name: VariableGroup.TripInformation,
        validity_date: VariableGroup.TripInformation,
        version_number: VariableGroup.TripInformation,
        remaining_price_to_pay: VariableGroup.TripInformation,
        
        user_ta: VariableGroup.Seller,
        user_ta_avatar_url: VariableGroup.Seller,
        user_ta_email: VariableGroup.Seller,
        user_ta_first_name: VariableGroup.Seller,
        user_ta_last_name: VariableGroup.Seller,
        user_ta_phone_number: VariableGroup.Seller,
        user_ta_title: VariableGroup.Seller,

        
        trip_owner_phone_number: VariableGroup.TOUser,
        trip_owner_name: VariableGroup.TOUser,
        client_logo: VariableGroup.TOUser,
        client_name: VariableGroup.TOUser,
        user_to: VariableGroup.TOUser,
        user_to_email: VariableGroup.TOUser,
        user_to_first_name: VariableGroup.TOUser,
        user_to_last_name: VariableGroup.TOUser,
        user_to_phone_number: VariableGroup.TOUser,
        user_to_title: VariableGroup.TOUser
    };

    // Vérifie si la variable est définie dans le tableau
    return variableGroups[variableName] || VariableGroup.Others;
}